import './DashboardCard.css';
import EVChargerIcon from '../../../assets/icons/charger.svg?react';
import { useMemo } from 'react';

// 충전기 상태코드를 3가지 카테고리로 매핑하는 헬퍼 함수
const getChargerStatusCategory = (statusCode) => {
  switch (statusCode) {
    case 2: // 충전대기
    case 6: // 예약중
      return 'waiting';
    case 3: // 충전중
      return 'using';
    case 0: // 알수없음
    case 1: // 통신이상
    case 4: // 운영중지
    case 5: // 점검중
    case 9: // 상태미확인
    default:
      return 'unavailable';
  }
};

const EVChargerCard = ({ colSpan = 1, rowSpan = 1, dashboardData = {} }) => {
  const { drResourceData } = dashboardData;
  
  // DR 자원 데이터에서 충전기 수 및 상태 계산
  const chargerStats = useMemo(() => {
    if (!drResourceData?.Items || drResourceData.Items.length === 0) {
      return { total: 0, waiting: 0, using: 0, unavailable: 0 };
    }
    
    const drResource = drResourceData.Items[0];
    const chargers = drResource?.Chargers || [];
    const total = chargers.length;
    
    // 모든 충전소의 충전기를 모아서 상태별로 계산
    let waiting = 0;
    let using = 0;
    let unavailable = 0;
    
    chargers.forEach(charger => {
      const status = charger.Status;
      if (status === 2 || status === 6) {
        waiting++;
      } else if (status === 3) {
        using++;
      } else {
        unavailable++;
      }
    });
    
    return { total, waiting, using, unavailable };
  }, [drResourceData]);
  
  return (
    <div 
      className="dashboard-card flex flex-col justify-between"
    >
      <div className="icon-container icon-yellow">
        <EVChargerIcon/>
      </div>
      <div className="dashboard-card-content flex flex-col gap-10">
        <h3 className="text-b1-700 text-gray-600">할당된 EV 충전기</h3>
        <div className='flex flex-row align-center gap-10'>
          <div className="text-h1 text-base">{chargerStats.total}</div>
          <div className="charger-status">
            <span className='text-gray-600'>대기 <span className='text-blue-500'>{chargerStats.waiting}</span></span>
            <span className='text-gray-600'>사용 <span className='text-green-400'>{chargerStats.using}</span></span>
            <span className='text-gray-600'>불가 <span className='text-yellow-500'>{chargerStats.unavailable}</span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EVChargerCard;
